<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" lazy-validation>
            <v-card-title>Créer sous duaa avec duaa </v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-select
                    v-model="duaa"
                    :return-object="true"
                    clearable
                    label="duaa"
                    :items="duaaArray"
                    item-text="title"
                    :rules="rule"
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="duaaTitre"
                    label="Titre"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="duaaTitreEn"
                    label="Titre en Anglais"
                    outlined
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Commentaire</label>
                  <VueEditor
                    v-model="duaaComment"
                    auto-grow
                    outlined
                    label="duaaComment"
                    :rules="rule"
                    placeholder="duaa Commentaire"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Commentaire en Anglais</label>
                  <VueEditor
                    v-model="duaaCommentEn"
                    auto-grow
                    outlined
                    label="duaaComment en anglais"
                    :rules="rule"
                    placeholder="duaa Commentaire en anglais"
                  >
                  </VueEditor>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <label for="">Duaa en Arabe</label>
                  <VueEditor
                    v-model="duaaEnArabe"
                    auto-grow
                    outlined
                    label="Duaa en arabe"
                    :rules="rule"
                    placeholder="Duaa en arabe: Nous voilà de retour, repentants, dévoués et proclamant la louange de notre Seigneur."
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <label for="">Duaa en Francais</label>

                  <VueEditor
                    v-model="duaaEnFrancais"
                    auto-grow
                    outlined
                    label="Duaa en français"
                    :rules="rule"
                    placeholder="Duaa en français: Nous voilà de retour, repentants, dévoués et proclamant la louange de notre Seigneur."
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <label for="">Duaa en Anglais</label>

                  <VueEditor
                    v-model="duaaEnAnglais"
                    auto-grow
                    outlined
                    label="Duaa en anglais"
                    :rules="rule"
                    placeholder="Duaa en anglais: Here we are back, repentant, devoted, and proclaiming the praise of our Lord."
                  >
                  </VueEditor>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Phonetic</label>
                  <VueEditor
                    v-model="phonetic"
                    auto-grow
                    outlined
                    label="phonetic"
                    :rules="rule"
                    placeholder="Phonetic Âyibûn, tâibûn, ‘âbidûn, li-Rabbinâ hâmidûn."
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <vue-upload-multiple-image
                    v-if="duaaTitre"
                    v-model="images"
                    accept="image/*	"
                    :data-images="images"
                    name="images"
                    drag-text="Veuillez ajoutez une images svp!"
                    browse-text="Browse image"
                    primary-text="Primary image"
                    mark-is-primary-text="Set default image"
                    :min-image="1"
                    :multiple="false"
                    :loading="load"
                    popup-text="Description default image"
                    drop-text="Drag and drop"
                    @upload-success="uploadImageSuccess"
                    @before-remove="beforeRemove"
                    @images-updated="handleImagesUpdated"
                  >
                  </vue-upload-multiple-image>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="numberRepetition"
                    label="Nomber de repetition"
                    type="number"
                    outlined
                    placeholder="0"
                    :min="0"
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="2">
                  <v-text-field
                    outlined
                    v-model="notificationTime"
                    label="Temp de notification"
                    model-value="12:30"
                    type="time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="notificationTitle"
                    label="text de notification"
                    outlined
                    placeholder="text de notification"
                    persistent-placeholder
                    v-show="notificationTime !== null && notificationTime != ''"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor
                    v-model="notificationBody"
                    auto-grow
                    outlined
                    v-show="notificationTime !== null && notificationTime != ''"
                    label="Contenu du notification"
                    placeholder="Contenu du notification"
                  >
                  </VueEditor>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      class="ml-6 mt-4"
                      color="info"
                      @click="ConfirmeAddSousDuaa()"
                      :disabled="
                        duaaTitre === '' ||
                        duaaTitreEn === '' ||
                        duaaComment === '' ||
                        duaaCommentEn === '' ||
                        duaaEnArabe === '' ||
                        duaaEnFrancais === '' ||
                        duaaEnAnglais === '' ||
                        duaa === null ||
                        phonetic === '' ||
                        (notificationTime !== null &&
                          notificationTime != '' &&
                          (notificationTitle === null ||
                            notificationBody === null ||
                            notificationTitle === '' ||
                            notificationBody === ''))
                      "
                      :loading="isLoading"
                    >
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-card-title>List sous duaa </v-card-title>
          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12" sm="12" md="12" xs="12">
                <v-select
                  v-model="duaaList"
                  :return-object="true"
                  clearable
                  label="duaa"
                  :items="duaaArray"
                  item-text="title"
                  outlined
                  @change="getSousDuaaByDuaatId"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12" xs="12">
                <v-data-table
                  v-if="duaaList"
                  :loading="isLoadingTables"
                  :headers="headers"
                  :items="duaaItemList"
                  class="elevation-1"
                  item-key="id"
                  loading-text="Loading..."
                  :footer-props="{
                    'items-per-page-options': [5, 10, 15, 30],
                  }"
                >
                  <template v-slot:[`item.imageUrl`]="{ item }">
                    <v-img
                      v-if="item.imgDBType != 'svg'"
                      :src="item.imgUrl"
                      width="65"
                      height="65"
                    />
                    <div
                      v-if="item.imgDBType === 'svg'"
                      v-html="item.svgContent"
                    ></div>

                    <v-divider></v-divider>
                  </template>
                  <template v-slot:[`item.notificationInfo`]="{ item }">
                    <span v-if="item.notificationTitle">
                      <h1><b>Titre: </b>{{ item.notificationTitle }}</h1>
                      <p>Contenu :{{ item.notificationBody }}</p>
                    </span>
                  </template>

                  <template v-slot:[`item.modifier`]="{ item }">
                    <v-icon @click="redirectToEditSousDuaa(item.id)">
                      {{ icons.mdiPencil }}
                    </v-icon>
                  </template>
                  <template v-slot:[`item.supprimer`]="{ item }">
                    <v-icon @click="suppressionAction(item)">
                      {{ icons.mdiDeleteOutline }}
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogAlertError" persistent max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Erreur lors de l'insertion de sous duaa.
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="info darken-1 " text @click="Clear()"> OK </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogAddSousDuaa" persistent max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Etes vous sur de vouloir ajouter le sous duaa ?
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="cancelleCallback">
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              :loading="isLoading"
              text
              @click="AddSousDuaa()"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogdeleteSousDuaa" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le sous duaa ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogdeleteSousDuaa = false"
            >
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              text
              @click="deleteSousDuaa()"
              :loading="isLoading"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogEditGroupe" persistent max-width="800">
        <v-card>
          <v-alert v-if="alerteExistEdit" type="error">
            Groupement existait déjà ou veset dans un autre groupe.
          </v-alert>
          <v-card-text class="mt-4">
            <v-row>
              <v-col cols="12" sm="12" md="12" xs="12">
                <v-autocomplete
                  :return-object="true"
                  clearable
                  v-model="selectedVersetToEdit"
                  :items="listVersetByduaaeToEdit"
                  item-text="french_text"
                  label="Début du groupe verset"
                  variant="outlined"
                  @change="updateFinDuGroupeVersetToEdit"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" xs="12">
                <v-autocomplete
                  :return-object="true"
                  clearable
                  v-model="selectedFinVersetToEdit"
                  :items="filteredFinVersetToEdit"
                  item-text="french_text"
                  label="Début du groupe verset"
                  variant="outlined"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="CancelEditGroupe()"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="ConfirmeEditGroupe()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import { component as VueCodeHighlight } from "vue-code-highlight";
import {
  mdiPlus,
  mdiDeleteOutline,
  mdiPencil,
  mdiDatabasePlusOutline,
} from "@mdi/js";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import axios from "axios";
import Constant from "@/utils/constants";
import { getAllduaa } from "@/views/qorani/services/services";
import store from "../../../store/image";
import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  components: { VueEditor, VueCodeHighlight, VueUploadMultipleImage },
  data() {
    return {
      dialogAlertError: false,
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
        mdiDatabasePlusOutline,
      },
      headers: [
        { text: "Image", value: "imageUrl" },
        { text: "Titre", value: "title" },
        { text: "Commentaire", value: "comment" },
        { text: "Duaa en arabe", value: "arabic_text" },
        { text: "Duaa en français", value: "french_text" },
        { text: "Phonétique", value: "phonetic" },
        { text: "Nombre de repetition", value: "numberRepetition" },
        { text: "Temps de notification", value: "notificationTime" },
        { text: "Notification", value: "notificationInfo" }, // Colonne fusionnée
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      isLoading: false,
      load: false,

      isLoadingTables: false,
      radioOptions: [],
      selectedGroupeValue: null,
      idSousDuaaSupprimmer: null,
      min: 1,
      max: 800,
      range: [0, 1],
      versetGroupeArray: [],
      selectedVerset: null,
      selectedFinVerset: null,
      filteredFinVerset: [],
      themeArray: [],
      theme: null,
      Soustheme: null,
      filteredProphets: [],
      dialogAddSousDuaa: false,
      dialogSelectGroupe: false,
      versetGroup: {
        duaaId: "",
        verset_start: "",
        verset_end: "",
      },
      listVersetByduaae: [],
      /* duaa variable*/
      duaaList: null,
      duaaArray: [],
      duaa: null,
      images: [],

      imagesUpload: [],

      duaaTitre: "",
      duaaTitreEn: "",
      duaaComment: "",
      duaaCommentEn: "",
      duaaEnArabe: "",
      duaaEnFrancais: "",
      duaaEnAnglais: "",
      numberRepetition: null,
      notificationTime: null,
      notificationTitle: null,
      notificationBody: null,
      phonetic: "",
      rule: [(v) => !!v || "Ce champ est requis"],
      duaaItemList: [],
      dialogdeleteSousDuaa: false,
      idGroupeSupprimmer: null,
      dialogEditGroupe: false,
      idGroupeEdit: null,
      listVersetByduaaeToEdit: [],
      selectedVersetToEdit: null,
      selectedFinVersetToEdit: null,
      filteredFinVersetToEdit: [],
      alerteExistEdit: false,
    };
  },
  methods: {
    async loadImage(item) {
      if (item.imgDBType === "svg") {
        try {
          const response = await fetch(
            `${Constant.QORANI}fileDB/files/${item.imgDBId}`
          );
          if (!response.ok)
            throw new Error("Échec du chargement de l'image SVG");

          let svgContent = await response.text();

          // Ajoute width et height directement dans le SVG
          svgContent = svgContent
            .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
            .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

                this.$set(item, 'svgContent', svgContent); // Stockage dans l'objet item
        } catch (error) {
          console.error("Erreur lors du chargement de l'image :", error);
        }
      } else {
        this.$set(item, 'imgUrl', `${Constant.QORANI}fileDB/files/${item.imgDBId}`);
      }
    },

    getImageUrl(imgDBId) {
      return `${Constant.QORANI}fileDB/files/${imgDBId}`;
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        await store.dispatch("uploadImageSuccess", {
          formData,
          index,
          fileList,
        });
        const imageId = store.state.imageId;
        // console.log("Image id :", imageId);
      } catch (error) {
        // console.error("Failed to upload image:", error);
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        const indexInArrayImages = this.imagesUpload.indexOf(
          fileList[index].path
        );
        this.imageUrl = "";
        this.imageId = "";
        if (index > -1) {
          this.imagesUpload.splice(indexInArrayImages, 1);
        }

        done();
      }
    },
    handleImagesUpdated(images) {
      const uploadedImage = images[0];
      // console.log("Uploaded image:", uploadedImage);
    },
    Clear() {
      this.dialogAlertError = false;
      this.dialogEditGroupe = false;
      this.dialogAddSousDuaa = false;
    },
    ClearNewSousDuaa() {
      this.theme = null;
      this.Soustheme = null;
      this.duaa = null;
      this.selectedVerset = null;
      this.selectedFinVerset = null;
      this.filteredFinVerset = [];
      this.filteredProphets = [];
    },
    async ConfirmeEditGroupe() {
      try {
        const versetGroupeEdit = {};
        versetGroupeEdit.sousThemeId = this.idGroupeEdit.sousThemeId;
        versetGroupeEdit.versetGroupStart =
          this.selectedVersetToEdit.verse_number;
        versetGroupeEdit.versetGroupEnd =
          this.selectedFinVersetToEdit.verse_number;

        const response = await fetch(
          Constant.QORANI +
            `verset/editPropheteToVerset/${this.idGroupeEdit.versetGroupId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(versetGroupeEdit),
          }
        );

        // Check if the response status is ok
        if (response.ok) {
          const jsonResponse = await response.json();
          if (jsonResponse) {
            window.location.reload();
          }
        } else {
          // console.error("Request failed with status:", response.status);
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    },
    CancelEditGroupe() {
      this.idGroupeEdit = null;
      this.dialogEditGroupe = false;
      this.selectedFinVersetToEdit = null;
      this.selectedVersetToEdit = null;
      this.alerteExistEdit = false;
    },
    updateFinDuGroupeVersetToEdit() {
      if (this.selectedVersetToEdit) {
        const selectedVerseNumber = this.selectedVersetToEdit.verse_number;
        this.selectedFinVersetToEdit = null;
        this.filteredFinVersetToEdit = this.listVersetByduaaeToEdit.filter(
          (verse) => verse.verse_number >= selectedVerseNumber
        );
      }
    },

    async redirectToEditSousDuaa(id) {
      console.log(id);

      this.$router.push({
        name: "EditSousDuaa",
        params: { id: id },
      });
    },
    suppressionAction(item) {
      this.idSousDuaaSupprimmer = item.id;
      // this.dialogdeleteSousDuaa = true;
      this.deleteSousDuaa();
    },
    async deleteSousDuaa() {
      this.isLoading = true;
      const response = await fetch(
        Constant.QORANI + `duaaItem/delete/${this.idSousDuaaSupprimmer}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogdeleteSousDuaa = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogdeleteSousDuaa = false;
      }
    },
    async getSousDuaaByDuaatId() {
      console.log(this.duaaList.id);

      this.isLoadingTables = true;
      try {
        const response = await axios.post(
          `${Constant.QORANI}duaaItem/getall/`,
          {
            pageNumber: 0,
            pageSize: 50,
            fieldId: this.duaaList.id,
          }
        );
        // console.log(this.duaaList);

        console.log(response.data);

        this.duaaItemList = response.data.duaaItemResponseList;
        this.duaaItemList.forEach(async (item) => {
          console.log(item);

          if (item.imgDBId) {
            await this.loadImage(item);
          }
        });
      } catch (error) {
        console.error("An error occurred:", error);
        throw error;
      }
      this.isLoadingTables = false;
    },
    cancelleCallback() {
      this.dialogAddSousDuaa = false;
    },
    ConfirmeAddSousDuaa() {
      // this.dialogAddSousDuaa = true;
      this.AddSousDuaa();
    },

    updateFinDuGroupeVerset() {
      if (this.selectedVerset) {
        const selectedVerseNumber = this.selectedVerset.verse_number;
        this.selectedFinVerset = null;
        this.filteredFinVerset = this.listVersetByduaae.filter(
          (verse) => verse.verse_number >= selectedVerseNumber
        );
      }
    },

    /*--------------------------*/
    async AddSousDuaa() {
      this.isLoading = true; // Début du chargement
      const imageId = store.state.imageId;

      try {
        const SousDuaa = {};
        SousDuaa.title = this.duaaTitre;
        SousDuaa.titleEn = this.duaaTitreEn;
        SousDuaa.comment = this.duaaComment;
        SousDuaa.commentEn = this.duaaCommentEn;
        SousDuaa.imgDBUrlId = imageId;
        SousDuaa.arabic_text = this.duaaEnArabe;
        SousDuaa.french_text = this.duaaEnFrancais;
        SousDuaa.english_text = this.duaaEnAnglais;
        SousDuaa.phonetic = this.phonetic;
        SousDuaa.duaaId = this.duaa.id;
        SousDuaa.numberRepetition = this.numberRepetition;
        SousDuaa.notificationTime =
          this.notificationTime == "" ? null : this.notificationTime;
        SousDuaa.notificationTitle =
          SousDuaa.notificationTime == null ? null : this.notificationTitle;
        SousDuaa.notificationBody =
          SousDuaa.notificationTime == null ? null : this.notificationTitle;

        const response = await fetch(Constant.QORANI + "duaaItem/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(SousDuaa),
        });

        // Check if the response status is ok
        if (response.ok) {
          window.location.reload();
        } else {
          this.isLoading = false; // Fin du chargement
          this.dialogAlertError = true;
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    },
  },
  async created() {
    this.duaaArray = await getAllduaa();
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
